export const renderPlaceholderContainers = (element, count, type) => {
  if (!element) return;
  const placeholderTemplates = Array.from(Array(count).keys()).map(() => `
      <div class="placeholder-loader${type ? ` placeholder-loader--${type}` : ''}">
        <div class="placeholder-loader__content"></div>
      </div>
    `).join('');
  element.innerHTML = placeholderTemplates;
};
